import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { Button } from "arv-reactcomponents";
import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";

const onLocatorClick = () => {
  Analytics.trackEvent({
    action: Event.action.STORE_LOCATOR_CLICK,
    label: Event.label.getSource(window.pageType),
    category: Event.category.TOP_ABOVE_MENU_CTR,
  });
};

const StoreLocator = props => {
  const { className, text } = props;

  return (
    <Button
      className={`nw-actionbuttons-marker ${className}`}
      onClick={onLocatorClick}
    >
      <Link
        className="nwc-text-primary nw-actionbuttons-btn nw-actionbuttons-locatorlink"
        href="/store-locator"
        to="/store-locator"
        target="_self"
      >
        <i className="icomoon-marker3" />
        <span className="nw-actionbuttons-text">{text}</span>
      </Link>
    </Button>
  );
};

StoreLocator.defaultProps = {
  className: "",
  text: "",
};

StoreLocator.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};

export default StoreLocator;



// WEBPACK FOOTER //
// ./src/component/Header/ActionButtons/StoreLocator/index.js